import axios from 'axios'

export default {
  checkToken (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/token/${opts}`)
        .then(({ data }) => {
          if (data.id) {
            resolve(true)
          } else {
            resolve(false)
          }
        }).catch((error) => reject(error))
    })
  }
}
